export default "/images/icons8-south_korea.png?b90ea611ef92807aac3fcb46ca520393";